<app-dialog class="edit-region-name-dialog">
  <ng-container dialog-title>
    <h4 class="header">{{ title }}</h4>
  </ng-container>
  <ng-container dialog-content>
    <div class="add-edit-region">
      <div class="input-group">
        <label class="label">{{ label }}</label>
        <label class="label">{{ description }}</label>
      </div>
      <div class="input-group2">
        <label class="label">{{ secondLabel }}</label>
        <mat-form-field class="input-field">
          <input #regionNameInput matInput class="input" [(ngModel)]="regionName" placeholder="Neuer Regionname" maxLength="50" />
        </mat-form-field>
      </div>
      <div class="button-section">
        <button class="btn btn-outline-primary" (click)="decline()">
          {{ cancelText }}
        </button>
        <button
          class="btn btn-outline-primary"
          (click)="confirm()"
          [disabled]="regionName === null || regionName === undefined || regionName.trim().length <= 0"
        >
          {{ saveText }}
        </button>
      </div>
    </div>
  </ng-container>
</app-dialog>
